import { render, staticRenderFns } from "./BowAnimation.vue?vue&type=template&id=318d3d70&"
import script from "./BowAnimation.vue?vue&type=script&lang=js&"
export * from "./BowAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports